import {User} from '../../../shared/models';
import {UserService} from '../../../shared/services';
import {Inject} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';

export class UserDetailsResolver implements Resolve<User> {

  constructor( @Inject(UserService) private userService: UserService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> {
    return this.userService.findByIdAndFetchDetails(+route.paramMap.get('id'));
  }
}
